<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				会员信息: <span v-if="customer!=null" class="red">
					{{ customer.CustomerName +' '+ customer.CustomerPhone }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					账号押金:{{customer.Deposit |rmb }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					可借数量:{{customer.booksCount}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					待还数量:{{customer.borrowBooksCount }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					剩余数量:{{customer.booksCount -customer.borrowBooksCount }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					到期时间:{{customer.VipEndDate }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">

			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>应付款</th>
							<th>实付款</th>
							<th>类型</th>
							<th>备注</th>
							<th>付款时间</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in history">
							<td>{{index+1}}</td>
							<td>
								{{i.PayMoney|rmb}}
							</td>

							<td>
								{{i.Disbursements|rmb}}
							</td>
							<td>
								{{i.PayType|t}}
							</td>
							<td>
								{{i.PayDate}}
							</td>
							<td>
								{{i.Remarks}}
							</td>
						</tr>

					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<script>
	export default {
		name: 'orderyPayRecord',
		data() {
			return {
				customer: null,
				searchBookCode: '',
				getData: {},
				history: [],
				borrowCount: 0,
				OperatorID: this.$store.state.user.UserID,
				ShopID: this.$store.state.shopID,
				CustomerID: 0
			}
		},
		created() {
			this.getData = () => {
				this.CustomerID = this.$route.params.CustomerID;
				this.$request.request({
					url: 'Query/getCustomerByID',
					data: {
						CustomerID: this.CustomerID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.customer = res.customer;
						this.history = res.history;
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}
			this.getData();
		},
		methods: {},
		computed: {


		},
		filters: {
			t(v) {
				switch (v) {
					case 1:
						return '会员缴费';
					case 2:
						return '会员退费';
					case 3:
						return '缴纳押金';
					case 4:
						return '押金退还';
					case 5:
						return '阅读超时费';
					case 6:
						return '配送费';
					case 7:
						return '异常还书费';
					case 8:
						return '书籍售出';
					case 9:
						return '书箱收费';
					case 10:
						return '书箱退费';
					case 11:
						return '体验课收费';
					case 12:
						return '体验课退费';
				}

			},
			rmb(v) {
				return v + '元';
			}
		},
		watch: {
			$route(n, o) {
				if (n.path.indexOf('customerPayRecord') == -1) return;
				let nbooksid = n.params.CustomerID;
				let obooksid = o.params.CustomerID;
				if (nbooksid != obooksid)
					this.getData();
			}

		}

	}
</script>

<style>
</style>
